module.exports = __webpack_public_path__ + "static/media/YF_52_10.a892daa2.jpg";